import * as React from "react";
import { suspense } from "./api-data";
import { elementWidth } from "./dimensions";

import { GroupContainer, GroupTitle } from "./group-container";
import { Part } from "./part";

const useDeferredValue = suspense.get("useDeferredValue");
const useTransition = suspense.get("useTransition");
const startTransition = suspense.get("startTransition");
const Suspense = suspense.get("Suspense");
const lazy = suspense.get("lazy");

export function SuspenseGroup({ scaleItems }) {
  return (
    <GroupContainer>
      <ul className="flex h-full w-full gap-x-8 px-5 py-4">
        <Part
          data={lazy}
          className={`w-[${elementWidth}px]`}
          name={"lazy"}
          scaleItems={scaleItems}
        />

        <div className={`flex flex-col gap-6 w-[${elementWidth}px]`}>
          <Part
            data={useTransition}
            name={"useTransition"}
            scaleItems={scaleItems}
          />
          <Part
            data={startTransition}
            name={"startTransition"}
            scaleItems={scaleItems}
          />
        </div>
        <div className={`flex flex-col gap-6 w-[${elementWidth}px]`}>
          <Part
            // className={"w-[300px]"}
            data={useDeferredValue}
            name={"useDeferredValue"}
            scaleItems={scaleItems}
          />
          <Part data={Suspense} name={"Suspense"} scaleItems={scaleItems} />
        </div>
      </ul>
      <GroupTitle>Suspense</GroupTitle>
    </GroupContainer>
  );
}
